import React from 'react';

const ResponsiveImage = ({
                             alt,
                             src,
                             desktop,
                             tablet,
                             mobile,
                             className
                         }) => {
    return (
        <picture className={className}>
            {desktop && (
                <source
                    type="image/webp"
                    media="(min-width: 1024px)"
                    srcSet={desktop}
                />
            )}

            {tablet && (
                <source
                    type="image/webp"
                    media="(min-width: 600px)"
                    srcSet={tablet}
                />
            )}

            {mobile && (
                <source
                    type="image/webp"
                    media="(max-width: 599px)"
                    srcSet={mobile}
                />
            )}

            <img
                src={src}
                alt={alt}
                loading="lazy"
                className={className}
            />
        </picture>
    );
};

export default ResponsiveImage;
